import loadLazyVideos from "./elements/lazy_video.mjs"

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

loadLazyVideos()

const posts = document.querySelectorAll('.page-informations__page-item')

posts.forEach(post => {
  
  let image = post.querySelector('.page-informations__page-image')
  let image_mask = post.querySelector('.page-informations__page-image-mask')
  let title = post.querySelector('.page-informations__page-title')
  let excerpt = post.querySelector('.page-informations__page-info-text')
  let button = post.querySelector('.page-informations__page-info-button')
  
  if(window.innerWidth > 600){
    let post_timeline = gsap.timeline({
      scrollTrigger: {
        trigger: post,
        start: 'top center-=100',
        onEnter: () => {
          gsap.to(image, {opacity: 1, duration: 0.5})
          gsap.to(image_mask, {scale: 1.0, duration: 1.5})
          gsap.to(title, {opacity: 1, x: 0, duration: 0.5})
          gsap.to(excerpt, {opacity: 1, x: 0, duration: 0.5})
          gsap.to(button, {opacity: 1, x: 0, duration: 0.5})
        }
      }
    })
  }else{
    gsap.to(image, {opacity: 1, duration: 0})
    gsap.to(image_mask, {scale: 1.0, duration: 0})
    gsap.to(title, {opacity: 1, x: 0, duration: 0})
    gsap.to(excerpt, {opacity: 1, x: 0, duration: 0})
    gsap.to(button, {opacity: 1, x: 0, duration: 0})
  }
})